export default __webpack_public_path__ + "f2755efbdff4489912e062c84c9e0d55.png";